function showCoupons(){
  let showCoupon = document.querySelector(".t4s-mini_cart_tool_btn.is--coupons");
  let availableCoupons = document.querySelector(".t4s-mini_cart-tool__conten.is--coupons");
  let closeCoupon = document.querySelector(".t4s-coupon-close");

showCoupon?.addEventListener("click",function(){
    availableCoupons.classList.add("show-coupons");
})
closeCoupon?.addEventListener("click",function(){
  availableCoupons.classList.remove("show-coupons");
})
 const downloadBtn = document.querySelector(".t4s-app-download-btn");
    
    if (!downloadBtn) {
      console.warn("Download button not found.");
      return;
    }

    console.log("App download button loaded.");

    downloadBtn.addEventListener("click", function () {
      const ua = navigator.userAgent || navigator.vendor || window.opera;

      if (/android/i.test(ua)) {
        window.location.href = "https://play.google.com/store/apps/details?id=com.urbanmonkey";
      } else if (/iPhone|iPad|iPod/i.test(ua)) {
        window.location.href = "https://apps.apple.com/app/id6473783031";
      } else {
        alert("Please open this on your mobile device to download the app.");
      }
    });

document.querySelectorAll('.t4s-coupon-apply').forEach(button => {
  button.addEventListener('click', function () {
    const coupon = this.getAttribute('data-coupon');
    const originalText = this.textContent;

    navigator.clipboard.writeText(coupon).then(() => {
      // Change button text to "Copied!"
      this.textContent = 'Copied!';
      
      // Optional: also change style (like green color)
      this.style.color = 'green';

      setTimeout(() => {
        this.textContent = originalText;
        this.style.color = ''; // Reset to original style
      }, 1000);
    });
  });
});

}

document.addEventListener('load', () => {
  console.log("filters inner")
  setTimeout(() => {
    filtersort();
}, 3000);

  function filtersort(){
        if (document.querySelector('#gf-tree .globo-selected-items-wrapper .globo-selected-items')) {
        console.log('filter applied');
    } else {
        console.log('no filter applied');
        const titles = document.querySelectorAll('#gf-tree .gf-filter-contents .gf-block-title');
    
    if (titles.length > 0) {
        console.log(`${titles.length} titles found:`);
        titles.forEach((title, index) => {
            const name = title.textContent.trim();
    
            // Check if the name is not 'Product Type', 'Category', or 'Color'
            if (name !== 'Product Type' && name !== 'Category' && name !== 'Color') {
                // Get the closest '.gf-option-block' and add the 'hidden' class
                const optionBlock = title.closest('.gf-option-block');
                if (optionBlock) {
                    optionBlock.classList.add('hidden');
                    console.log(`Hidden class added to option block for title: "${name}"`);
                }
            }
    
            console.log(`Title ${index + 1}:`, name);
        });
    }else{
      console.log("title not found")
    }
    }
  }
});

// hiding notify button for first sold out variant and show choose size button
let addToCartBTN = document.querySelector(".t4s-swatch.variants-available");
let notifyButton = document.querySelector("#BIS_trigger");
if (addToCartBTN) {
  notifyButton?.classList.add("hidden");
}
// size chart text on PDP 
const sizeChartBlock = document.querySelector('.product-size-chart');
document.querySelectorAll('.t4s-swatch__item.variant-available')?.forEach(item => {
    item.addEventListener('click', function () {

      sizeChartBlock.style.display = 'block';
      // Get the data-value of the clicked item
      const selectedSize = this.getAttribute('data-value')?.toLowerCase();
      
      // Get all the size chart divs
      const sizeChartDivs = document.querySelectorAll('.product-size-chart [data-size]');
      // Loop through size chart divs and toggle the display
      sizeChartDivs.forEach(div => {
        if (div.getAttribute('data-size')?.toLowerCase() === selectedSize) {
          div.style.display = 'block';
        }else {
          div.style.display = 'none';
        }
      });
    });
});
document.querySelectorAll('.t4s-swatch__item.is--soldout')?.forEach(item => {
     item.addEventListener('click', function () {
      sizeChartBlock.style.display = 'none';
       notifyButton?.classList.remove("hidden")
     });
});



// topn sticky category navigation
let topStickyNav = document.getElementById('navigation');
if(topStickyNav){
let previousScrollY = window.scrollY || document.documentElement.scrollTop;
let isScrolling = false; // Flag to track scrolling activity

function detectScrollDirection() {
  let element = document.querySelector(".t4s-top-collections-section");
  let distanceToTop = element.offsetTop;
  let viewportHeight = window.innerHeight; // Use window.innerHeight for accurate viewport height

  // Calculate element's bottom position relative to viewport
  let elementBottom = distanceToTop + element.offsetHeight;
  let height = viewportHeight - (viewportHeight - window.scrollY); // Use height instead of view
     
  const currentScrollY = Math.max(window.scrollY, document.documentElement.scrollTop);

  if (previousScrollY !== currentScrollY) {
    isScrolling = true; // Set flag if scroll position changed
  }

  if (isScrolling) {
    let scrollDirection = "forward"; // Assume forward scrolling initially

    if (previousScrollY > currentScrollY) {
      scrollDirection = "backward";
    }

    console.log("Scroll direction:", scrollDirection);
    
    if (scrollDirection === "forward") {
      if(!document.querySelector("#shopify-section-header-categories-menu").classList.contains('shopify-section-header-hidden')){
        document.getElementById('navigation').style.cssText +=`top: 0px`;
      }
      if (height + 10 > elementBottom) { // Use height here
        document.getElementById('navigation').style.cssText += `display: block;`;
      } else {
        document.getElementById('navigation').style.cssText += `display: none;`;
      }
    } else if (scrollDirection === "backward") { // Strict equality for booleans
      if(document.querySelector("#shopify-section-header-categories-menu").classList.contains('shopify-section-header-hidden')){
        let px = document.querySelector("#shopify-section-header-categories-menu").offsetHeight;
        document.getElementById('navigation').style.cssText +=`top: ${px}px`;
      }
      if (height > elementBottom - 50) { // Use height here
        document.getElementById('navigation').style.cssText += `display: block;`;
      } else {
        document.getElementById('navigation').style.cssText += `display: none;`;
      }
    }

    previousScrollY = currentScrollY;
    isScrolling = false; // Reset flag after logging
  }

  // Schedule the next detection using requestAnimationFrame
  requestAnimationFrame(detectScrollDirection);
}

// Initial call to start detection
requestAnimationFrame(detectScrollDirection);
}
  
// Select the image and attach a click event listener
const imageElement = document.querySelector(".product-detail-image-container img");
imageElement?.addEventListener("click", () => openFullscreen(imageElement));

function openFullscreen(imgElement) {
    const fullscreenImage = imgElement.cloneNode();
    fullscreenImage.classList.add("fullscreen");
    document.body.appendChild(fullscreenImage);

    fullscreenImage.addEventListener("click", () => fullscreenImage.remove()); // Close on click

    let scale = 1;
    let initialDistance = null;
    let lastTouchX = 0, lastTouchY = 0;
    let offsetX = 0, offsetY = 0;
    let isDragging = false;

    function onTouchMove(event) {
        if (event.touches.length === 2) {
            // Handle pinch-to-zoom
            const touch1 = event.touches[0];
            const touch2 = event.touches[1];
            const currentDistance = Math.hypot(
                touch2.pageX - touch1.pageX,
                touch2.pageY - touch1.pageY
            );

            if (initialDistance === null) {
                initialDistance = currentDistance;
            } else {
                scale = Math.max(1, currentDistance / initialDistance);
                updateTransform();
            }
        } else if (event.touches.length === 1 && scale > 1) {
            // Handle panning if the image is zoomed
            const touch = event.touches[0];
            if (isDragging) {
                const deltaX = touch.pageX - lastTouchX;
                const deltaY = touch.pageY - lastTouchY;
                offsetX += deltaX;
                offsetY += deltaY;
                clampPosition();
                updateTransform();
            }
            lastTouchX = touch.pageX;
            lastTouchY = touch.pageY;
            isDragging = true;
        }
    }

    function onTouchEnd() {
        initialDistance = null;
        isDragging = false;
    }

    function updateTransform() {
        fullscreenImage.style.transform = `scale(${scale}) translate(${offsetX / scale}px, ${offsetY / scale}px)`;
    }

    // Function to clamp the position within the bounds
    function clampPosition() {
        const imgWidth = fullscreenImage.offsetWidth * scale;
        const imgHeight = fullscreenImage.offsetHeight * scale;
        const viewportWidth = window.innerWidth;
        const viewportHeight = window.innerHeight;

        // Calculate max offset values to prevent moving out of bounds
        const maxOffsetX = Math.max(0, (imgWidth - viewportWidth) / 2);
        const maxOffsetY = Math.max(0, (imgHeight - viewportHeight) / 2);

        // Clamp offsetX and offsetY within allowed bounds
        offsetX = Math.min(maxOffsetX, Math.max(-maxOffsetX, offsetX));
        offsetY = Math.min(maxOffsetY, Math.max(-maxOffsetY, offsetY));
    }

    fullscreenImage.addEventListener("touchmove", onTouchMove);
    fullscreenImage.addEventListener("touchend", onTouchEnd);
}


// atc notification
function showCartNotification() {
  const notification = document.getElementById('cart-notification');
  const goToCartbtn = document.querySelector('#go-to-cart-btn');
  const cartClosebtn = document.querySelector('#mini-cart__close'); 
  const miniCart = document.querySelector('#t4s-mini_cart');
  const body = document.querySelector('body');
  
    notification.classList.add('show');
    
    setTimeout(() => {
        notification.classList.remove('show');
    }, 3000); // Notification stays for 3 seconds

  
  goToCartbtn?.addEventListener("click",function(){
    console.log("goto cart")
    miniCart.setAttribute('aria-hidden','false')
  });

  cartClosebtn?.addEventListener("click",function(){
    console.log("goto cart")
    miniCart.setAttribute('aria-hidden','true')
    body.classList.remove("t4s-lock-scroll");
  });
}

const submitButton = document.querySelector(".t4s-sticky-atc__atc");
submitButton?.addEventListener('click', function (e) {
  let variantID = submitButton.getAttribute("data-variant-id")
  if (variantID == ''){
    const variantsElement = document.querySelector('.t4s-product-form__variants');
      e.stopPropagation();

    // Check if the element is in the viewport
    const rect = variantsElement.getBoundingClientRect();
    const inViewport = (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );

        // Calculate the scroll position with 80px offset from the bottom
        const scrollOffset = window.pageYOffset + rect.top - (window.innerHeight - 180);

        // Scroll to the calculated position
        window.scrollTo({
            top: scrollOffset,
            behavior: 'smooth'
        });
   }
});


let PDPsimilarButton = document.querySelector(".similar-product-button");
  if(PDPsimilarButton){
      viewSimilarProducts()
  }
  // toggle functionality for view similar products pop up in PDP 
function viewSimilarProducts() {
  const viewSimilarContent = document.querySelector(".similar-product-content");
  const overlay = document.querySelector(".t4s-close-overlay");
  const body = document.querySelector("body");
  const closeButton = document.querySelector(".similar-product-close-btn");
  const viewSimilarButtons = document.querySelectorAll(".similar-product-button");

  viewSimilarButtons.forEach(button => button.addEventListener("click", popupOpen));
  overlay.addEventListener("click", popupClose);
  closeButton.addEventListener("click", (e) => { e.stopPropagation(); popupClose(); });

  function popupOpen() {
    viewSimilarContent.classList.add("content--visible");
    overlay.classList.add("is--visible");
    body.classList.add("t4s-lock-scroll");
  }

  function popupClose() {
    viewSimilarContent.classList.remove("content--visible");
    overlay.classList.remove("is--visible");
    body.classList.remove("t4s-lock-scroll");
  }
}


// filter functionality 

function filterClick(){
    // Select all .title elements
    const titles = document.querySelectorAll('.t4s-facet-title--wrapper .t4s-col-item');
    titles.forEach(title => {
        title.addEventListener('click', () => {
            const clickedId = title.id;     
          // Toggle active class on titles
            titles.forEach(t => t.classList.remove('active')); // Remove active class from all titles
            title.classList.add('active'); // Add active class to the clicked title 
          
            // Select all .content elements
            const contents = document.querySelectorAll('.t4s-facet-content--wrapper .t4s-col-item');
            
            contents.forEach(content => {
                if (content.id === clickedId) {
                    // Match found: Remove 'hidden' class if it exists
                    content.classList.remove('hidden');
                } else {
                    // Add 'hidden' class to all other content elements
                    content.classList.add('hidden');
                }
            });
        });
    });


  let filters = document.querySelectorAll(".t4s-filter__values a")
   filters.forEach(filter => {
        filter.addEventListener('click', () => {
             hideEmptyFilters();
        })
   })
}

  function hideEmptyFilterValues(){
          const filterLists = document.querySelectorAll(".t4s-filter__values");
            
            if (filterLists) {
              filterLists.forEach((filterList) => {

            
                // Get all <li> elements inside this particular filterList
                const listItems = filterList.querySelectorAll("li");
                 listItems.forEach(listItem=>{
                   if(listItem.classList.contains("is--disabled")){
                     listItem.classList.add('hidden')
                   }
                 })
              });
            }
}

  function hideEmptyFilters(){
          const filterLists = document.querySelectorAll(".t4s-filter__values");
            
            if (filterLists) {
              filterLists.forEach((filterList) => {

            
                // Get all <li> elements inside this particular filterList
                const listItems = filterList.querySelectorAll("li");
            
                // Check if all <li> elements have the 'is--disabled' class
                const shouldHide = Array.from(listItems).every((li) => li.classList.contains("is--disabled"));
            
                if (shouldHide) {

                  filterList.classList.add("empty-filter"); // Add class to indicate empty
                } else {
                  filterList.classList.remove("empty-filter"); // Remove class if not empty
                }
              });
            }

           // Find all filter lists with the 'empty-filter' class
  const emptyFilters = document.querySelectorAll(".t4s-filter__values.empty-filter");

  emptyFilters.forEach((emptyFilterList) => {
    // Get the closest parent `.t4s-col-item` and its ID
    const parentColItem = emptyFilterList.closest(".t4s-col-item");
    const parentColItemId =  parentColItem.id;

    if (parentColItemId) {
      // Find all `.t4s-col-item-title` elements inside `.t4s-facet-title--wrapper`
      const facetTitles = document.querySelectorAll(".t4s-facet-title--wrapper .t4s-col-item");
      facetTitles.forEach((facetTitle) => {
        const facetTitleId = facetTitle.id;
        // console.log("facetTitleId",facetTitleId,facetTitleId === parentColItemId);

        // Match IDs and hide `.t4s-col-item-title` if they match
        if (facetTitleId === parentColItemId) {
           console.log("facetTitle",facetTitleId,parentColItemId);
          facetTitle.style.display = "none"; // Hide the matching element
        }
      });
    }
  });hideEmptyFilterValues();
}


// footer newsletter subscribe
document.getElementById('t4s-form-webEngage')?.addEventListener('submit', function(event) {
    event.preventDefault(); // Prevent the default form submission

    const email = document.querySelector('input[name="email"]').value;

    let userDetails = {
        email: email
    };
    // Call WebEngage's track function
    webengageOnReady(function() {
        webengage.track('Footer Newsletter Subscribed', userDetails);
    });

    // Display a success message or handle further actions
    document.querySelector('.t4s-newsletter__success').style.display = 'block';
});

function webengageOnReady(cb) {
    if (typeof webengage === 'undefined' || typeof webengage.onReady !== 'function') {
        setTimeout(function() {
            webengageOnReady(cb);
        }, 100);
    } else {
        webengage.onReady(cb);
    }
}
// end footer newsletter subscribe

// webengage wishlist
window.wishlistCallback= function(object){ 
  // webengage
    if(object.event === 'ADD'){
     function webengageOnReady(cb) {
      if (typeof webengage === undefined || typeof webengage.onReady !== "function") {
          setTimeout(function() {
              webengageOnReady(cb);
          }, 100);
      } else {
          webengage.onReady(cb)
      }
    }
    webengageOnReady(function(){
     webengage.track('Add to Wishlist', object); 
    })
  }
}

jQuery_T4NT(document).ready(function($) {
   // $("#BIS_trigger").removeAttr('disabled');

     /**
     *  Variant selection changed
     *  data-variant-toggle="{{ variant.id }}"
     */
	   $( document ).on( "variant:changed", function( evt ) {
	     // console.log( evt.currentVariant );
	     // $('[data-variant-toggle]').hide(0);
	     // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
	   });
});